<template>
    <div class="login-container">
        <!-- Background Pattern -->
        <div class="background-pattern"></div>

        <!-- Main Content -->
        <div class="login-content">
            <!-- Left Side - Branding -->
            <div class="branding-section">
                <div class="branding-content">
                    <div class="logo-container">
                        <img src="img/bisigorta_logo_white.png" alt="Bisigorta" class="brand-logo" />
                    </div>
                    <h1 class="brand-title">Admin Panel</h1>
                    <p class="brand-subtitle">Güvenli ve kolay yönetim platformu</p>

                    <!-- Feature Icons -->
                    <div class="features">
                        <div class="feature-item">
                            <i class="fas fa-shield-alt"></i>
                            <span>Güvenli Erişim</span>
                        </div>
                        <div class="feature-item">
                            <i class="fas fa-chart-line"></i>
                            <span>Gerçek Zamanlı Analiz</span>
                        </div>
                        <div class="feature-item">
                            <i class="fas fa-users"></i>
                            <span>Kullanıcı Yönetimi</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Side - Login Form -->
            <div class="form-section">
                <div class="form-container">
                    <div class="form-header">
                        <h2>Hoş Geldiniz</h2>
                        <p>Hesabınıza giriş yapın</p>
                    </div>

                    <form class="login-form" @submit.prevent="methodLogin()">
                        <!-- Email Field -->
                        <div class="form-group">
                            <label for="email" class="form-label">
                                <i class="fas fa-envelope"></i>
                                E-posta Adresi
                            </label>
                            <cbcinput-vue v-model="login.form.email" :id="login.fields.email.id"
                                :name="login.fields.email.name" :type="login.fields.email.type"
                                :ref="login.fields.email.ref" :options="login.fields.email.options"
                                :disabled="login.disabled" />
                        </div>

                        <!-- Password Field -->
                        <div class="form-group">
                            <label for="password" class="form-label">
                                <i class="fas fa-lock"></i>
                                Şifre
                            </label>
                            <cbcinput-vue v-model="login.form.password" :id="login.fields.password.id"
                                :name="login.fields.password.name" :type="login.fields.password.type"
                                :ref="login.fields.password.ref" :options="login.fields.password.options"
                                :disabled="login.disabled" />
                        </div>

                        <!-- Login Button -->
                        <div id="btnLogin" type="submit" class="login-btn" style="text-transform:capitalize;"
                            :disabled="login.disabled" @click="methodLogin()">
                            <span v-if="!login.disabled">
                                <i class="fas fa-sign-in-alt mr-2"></i>
                                Giriş Yap
                            </span>
                            <span v-else>
                                <i class="fas fa-spinner fa-spin mr-2"></i>
                                Giriş Yapılıyor...
                            </span>
                        </div>

                        <!-- Additional Links -->

                    </form>
                </div>

                <!-- Version Info -->
                <div class="version-info">
                    <small>Versiyon 2.0 • © {{ new Date().getFullYear() }} Bisigorta</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

const md5 = require('md5');

export default {
    name: 'Login',
    components: {
    },
    data() {
        return {
            login: {
                disabled: false,
                fields: {
                    email: {
                        id: 'email',
                        name: 'email',
                        type: 'email',
                        ref: 'email',
                        options: {
                            placeholder: 'ornek@email.com',
                            width: '100%',
                            height: '50px',
                            color: '#2d3748',
                            backgroundColor: '#ffffff',
                            borderColor: '#e2e8f0',
                            placeholderColor: '#a0aec0',
                            focusColor: '#1565c0',
                            fontSize: '16px',
                            borderRadius: '12px',
                            maxlength: 50,
                            shaker: true,
                            inputIcon: {
                                status: false
                            },
                            validRequired: {
                                status: true,
                                errorMessage: 'Bu alanı boş bırakamazsınız!'
                            },
                            validLengthMin: {
                                status: true,
                                number: 10,
                                errorMessage: 'Bu alana en az <strong>10</strong> karakter girebilirsiniz!'
                            },
                            validRegExp: {
                                status: true,
                                regexp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                errorMessage: 'Hatalı e-posta formatı!',
                            }
                        }
                    },
                    password: {
                        id: 'password',
                        name: 'password',
                        type: 'password',
                        ref: 'password',
                        options: {
                            placeholder: 'Şifrenizi girin',
                            width: '100%',
                            height: '50px',
                            color: '#2d3748',
                            backgroundColor: '#ffffff',
                            borderColor: '#e2e8f0',
                            placeholderColor: '#a0aec0',
                            focusColor: '#1565c0',
                            fontSize: '16px',
                            borderRadius: '12px',
                            shaker: true,
                            passwordEyeButton: {
                                status: true,
                                color: '#1565c0'
                            },
                            inputIcon: {
                                status: false
                            },
                            validRequired: {
                                status: true,
                                errorMessage: 'Bu alanı boş bırakamazsınız!'
                            },
                            validLengthMin: {
                                status: true,
                                number: 6,
                                errorMessage: 'Bu alana en az <strong>6</strong> karakter girebilirsiniz!'
                            },
                            validLengthMax: {
                                status: true,
                                number: 25,
                                errorMessage: 'Bu alana en fazla <strong>25</strong> karakter girebilirsiniz!'
                            }
                        }
                    },
                },
                form: {
                    email: {
                        value: '',
                        valid: null
                    },
                    password: {
                        value: '',
                        valid: null
                    }
                }
            }
        };
    },
    mounted() {
        document.getElementById('email').focus(); // Sayfa açıldığında e-posta alanına focus yaptık
        document.getElementById('email').addEventListener('keyup', function (event) {
            if (event.keyCode === 13) { // Basılan tuş'un keyCode değeri 13 (Yani enter) ise
                event.preventDefault();
                document.getElementById('password').focus(); // password input'a focus oluyoruz.
            }
        });

        document.getElementById('password').addEventListener('keyup', function (event) {
            if (event.keyCode === 13) { // Basılan tuş'un keyCode değeri 13 (Yani enter) ise
                event.preventDefault();
                document.getElementById('btnLogin').click(); // Login button'un click özelliğini tetikliyoruz.
            }
        });
    },
    methods: {
        async methodLogin() {
            var inputErrors = [];

            this.$refs.email.validControl(true);
            inputErrors.push(this.login.form.email.valid);

            this.$refs.password.validControl(true);
            inputErrors.push(this.login.form.password.valid);

            // inputErrors array içinde false olan varsa
            if (inputErrors.includes(false) === true) return;

            var form = {
                email: this.login.form.email.value,
                password: md5(this.login.form.password.value)
            }

            this.$Progress.start();
            this.login.disabled = true;
            var loginResult = await this.$axios.post('admin/login', form);
            this.$Progress.finish();
            this.login.disabled = false;

            if (loginResult.data.result === 'success') {
                this.$store.commit('user', loginResult.data.user);
                this.$router.push('/anasayfa')

                /* Swal.fire({
                    icon: loginResult.data.result,
                    title: 'Giriş',
                    html: loginResult.data.message,
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didClose: () => this.$router.push('/anasayfa')
                }); */
            } else {
                Swal.fire({
                    icon: loginResult.data.result,
                    title: loginResult.data.message,
                    toast: true,
                    position: 'bottom-start',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 50%, #90caf9 100%);
    position: relative;
    overflow: hidden;

    .background-pattern {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background:
            radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
        animation: float 20s ease-in-out infinite;
    }

    @keyframes float {

        0%,
        100% {
            transform: translateY(0px) rotate(0deg);
        }

        50% {
            transform: translateY(-20px) rotate(2deg);
        }
    }
}

.login-content {
    display: flex;
    width: 100%;
    max-width: 1200px;
    min-height: 600px;
    background: rgba(255, 255, 255, 0.98);
    border-radius: 20px;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(20px);
    overflow: hidden;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        max-width: 400px;
        margin: 20px;
    }
}

// Left Side - Branding
.branding-section {
    flex: 1;
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 40px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
        opacity: 0.3;
    }

    .branding-content {
        text-align: center;
        color: white;
        position: relative;
        z-index: 2;
    }

    .logo-container {
        margin-bottom: 30px;
        animation: slideInLeft 0.8s ease-out;
    }

    .brand-logo {
        width: 180px;
        height: auto;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.05);
        }
    }

    .brand-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 15px;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        animation: slideInLeft 0.8s ease-out 0.2s both;
    }

    .brand-subtitle {
        font-size: 1.1rem;
        opacity: 0.9;
        margin-bottom: 40px;
        line-height: 1.6;
        animation: slideInLeft 0.8s ease-out 0.4s both;
    }

    .features {
        display: flex;
        flex-direction: column;
        gap: 20px;
        animation: slideInLeft 0.8s ease-out 0.6s both;
    }

    .feature-item {
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 15px 20px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.2);
            transform: translateX(10px);
        }

        i {
            font-size: 1.2rem;
            width: 20px;
            text-align: center;
        }

        span {
            font-weight: 500;
        }
    }

    @media (max-width: 768px) {
        padding: 40px 30px;

        .features {
            display: none; // Mobilde feature'ları gizle
        }

        .brand-subtitle {
            margin-bottom: 20px; // Alt boşluğu azalt
        }
    }
}

// Right Side - Form
.form-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 60px 50px;

    @media (max-width: 768px) {
        padding: 40px 30px;
    }
}

.form-container {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.form-header {
    text-align: center;
    margin-bottom: 40px;
    animation: slideInRight 0.8s ease-out;

    h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #2d3748;
        margin-bottom: 10px;
    }

    p {
        color: #718096;
        font-size: 1rem;
        margin: 0;
    }
}

.login-form {
    animation: slideInRight 0.8s ease-out 0.2s both;
}

.form-group {
    margin-bottom: 25px;

    .form-label {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        color: #4a5568;
        margin-bottom: 8px;
        font-size: 0.9rem;

        i {
            color: #1565c0;
            width: 16px;
        }
    }
}

.login-btn {
    width: 100%;
    height: 60px;
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    border: none;
    border-radius: 16px;
    color: white;
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.5px;
    margin-top: 20px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    // box-shadow: 0 8px 20px rgba(21, 101, 192, 0.3);
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
    }

    &:hover {
        //   transform: translateY(-3px);
        // box-shadow: 0 15px 35px rgba(21, 101, 192, 0.5);
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

        &::before {
            left: 100%;
        }
    }

    &:active {
        transform: translateY(0);
        scale: 0.90;
    }
}

.form-footer {
    text-align: center;
    margin-top: 30px;

    .help-text {
        color: #718096;
        font-size: 0.9rem;
        margin: 0;
    }

    .help-link {
        color: #1565c0;
        text-decoration: none;
        font-weight: 600;
        transition: color 0.3s ease;

        &:hover {
            color: #1976d2;
            text-decoration: underline;
        }
    }
}

.version-info {
    text-align: center;
    margin-top: auto;
    padding-top: 20px;

    small {
        color: #a0aec0;
        font-size: 0.8rem;
    }
}

// Animations
@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-50px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(50px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

// Responsive Design
@media (max-width: 768px) {
    .login-content {
        min-height: auto;
        margin: 10px;
    }

    .branding-section {
        min-height: 200px; // Daha kompakt yap
        padding: 30px 20px; // Padding'i azalt

        .brand-title {
            font-size: 1.8rem;
        }

        .brand-subtitle {
            font-size: 0.9rem;
            margin-bottom: 0;
        }
    }

    .form-header {
        margin-bottom: 30px; // Boşluğu azalt

        h2 {
            font-size: 1.5rem;
        }
    }
}

@media (max-width: 480px) {
    .login-container {
        padding: 10px;
    }

    .form-section {
        padding: 30px 20px;
    }

    .branding-section {
        padding: 30px 20px;
    }
}
</style>